import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

const ArticleUpdateContent = lazy(() => import('../../../../components/Pages/Articles/[articleId]/Update'));

export default function ArticleUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Article Update page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <ArticleUpdateContent />
      </Suspense>
    </Layout>
  );
}
